import { SPContainer } from "./SubscriptionsPlans.styled";
import { Title } from "./Title";
import { Instruments } from "../PricingActualPage/Instruments";
import { useStores } from "../../stores";
import { useEffect } from "react";
import { HEADER_TYPE } from "../../constants";
import { observer } from "mobx-react";
import { loadStripe } from "@stripe/stripe-js";
import { API } from "../../core";
import { Plans } from "./Plans";
import { GoodList } from "./GoodList";

interface SubscriptionsPlansProps {}

export const SubscriptionsPlansPage = observer(({}: SubscriptionsPlansProps) => {
	const { settingsStore, stripeStore, pricingActualStore, shopGoodsStore } = useStores();

	useEffect(() => {
		settingsStore.setTypeHeader(HEADER_TYPE.RELATIVE);
		// settingsStore.setIsWhiteMain(true);

		return () => {
			settingsStore.setIsWhiteMain(false);
		};
	}, []);

	/**
	 * Stripe JS
	 */
	useEffect(() => {
		(async () => {
			const result = await loadStripe(API.stripeKey);

			if (result) {
				stripeStore.setInstance(result);
			}
		})();
	}, []);

	/**
	 * Получение товаров в зависимости от выбранных фильтрах
	 */
	useEffect(() => {
		(async () => {
			// Записываем фильтры
			shopGoodsStore.filter.set("shop_good_plans_id", 1);
			shopGoodsStore.filter.set("shop_good_period_id", 1);
			shopGoodsStore.filter.set("instrument_id", pricingActualStore.instrument_id);

			// Получение товаров
			await shopGoodsStore.getList();
		})();
	}, []);

	/**
	 * При изменении инструмента, периода, плана обновляем данные
	 */
	useEffect(() => {
		(async () => {
			console.log("filter data", pricingActualStore);

			shopGoodsStore.filter.set("shop_good_plans_id", pricingActualStore.plan_id);
			shopGoodsStore.filter.set("shop_good_period_id", pricingActualStore.period_id);
			shopGoodsStore.filter.set("instrument_id", pricingActualStore.instrument_id);

			await shopGoodsStore.getList();
		})();
	}, [pricingActualStore.instrument_id, pricingActualStore.period_id, pricingActualStore.plan_id]);

	return (
		<SPContainer>
			<Title />
			<Instruments subscription />
			<Plans />
			<GoodList />
		</SPContainer>
	);
});
